export const product = {
  name: 'NASLink',
  tagline: 'いつものNASを、どこからでも。',
  description:
    'Tailnetを経由して、自宅やオフィスのSMBファイルへ安全にアクセスできるモバイルアプリです。',
};

export const navigationItems = [
  { label: '特徴', target: 'features' },
  { label: 'セキュリティ', target: 'security' },
];

export const features = [
  {
    number: '01',
    title: 'リモートアクセス',
    description:
      '外出先からでも、Tailnet内のNASへシンプルな操作でアクセスできます。',
  },
  {
    number: '02',
    title: 'SMBファイル閲覧',
    description:
      'フォルダをたどり、必要なファイルへすばやくアクセスできる画面設計です。',
  },
  {
    number: '03',
    title: '認証情報を保護',
    description:
      '接続に必要な認証情報は、端末のセキュアストレージで管理します。',
  },
];

export const securityPoints = [
  '公開ポートを増やさずにNASへ接続',
  '通信経路をTailnet内に限定',
  'パスワードを端末の安全な領域へ保存',
];

export const support = {
  email: 'okamurakohta1996@gmail.com',
  responseNote: '通常2〜3営業日以内に返信します。',
  reportHints: [
    'お使いの端末とOSのバージョン（例：iPhone 15 / iOS 18）',
    'NASLinkのバージョン（設定画面の下部に表示されます）',
    'どの画面で、どのような操作をしたときに起きたか',
    '表示されたエラーメッセージ（あれば）',
  ],
};

export const supportTopics = [
  {
    title: 'NASに接続できない',
    points: [
      'ホーム画面上部のバナーで、Tailnetに接続済みか確認してください。未接続の場合はバナーから認証を完了します。',
      'NASのIPアドレスまたはホスト名、共有名、SMBユーザー名とパスワードが正しいか確認してください。共有名が不明な場合は空欄のまま接続を試せます。',
      'NAS側でSMB2またはSMB3が有効になっているか確認してください。SMB1のみの環境には接続できません。',
      'NASとスマートフォンが同じTailnetに参加しているか確認してください。',
    ],
  },
  {
    title: 'ファイルやフォルダーが表示されない',
    points: [
      '接続に使用したSMBユーザーに、その共有・フォルダーへのアクセス権限があるか確認してください。',
      '隠しファイルは既定で表示されません。設定画面から表示を切り替えられます。',
    ],
  },
  {
    title: '写真ライブラリが読み込めない（iOS）',
    points: [
      '画像・動画の表示には写真へのアクセス許可が必要です。許可しない場合でも、書類とダウンロードは利用できます。',
      '一度許可を拒否すると、アプリ内からは再表示できません。端末の「設定」アプリからNASLinkの写真アクセスを変更してください。',
    ],
  },
  {
    title: 'Proの購入・復元について',
    points: [
      'Proにアップグレードすると、サーバー数の上限が解除され、広告が非表示になり、生体認証ロックが使えます。',
      '機種変更や再インストール後は、購入時と同じApp Store／Google Playアカウントで「購入を復元」を実行してください。',
    ],
  },
  {
    title: '広告とトラッキングについて',
    points: [
      '無料版は広告で運営しています。トラッキングを許可しなくても、すべての機能をそのまま利用できます。',
      '対象地域では、設定画面の「広告のプライバシー設定」から同意内容をいつでも見直せます。',
    ],
  },
];
